import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export type RouteBreadcrumbItem = {
  label: ReactNode;
  to?: string;
};

type RouteBreadcrumbProps = {
  items: RouteBreadcrumbItem[];
  separator?: ReactNode;
  className?: string;
};

export function RouteBreadcrumb({ items, separator = '/', className }: RouteBreadcrumbProps) {
  return (
    <div className={['text-muted-foreground text-sm', className].filter(Boolean).join(' ')}>
      {items.map((item, index) => (
        <span key={index}>
          {item.to ? (
            <Link to={item.to} className="hover:text-foreground underline-offset-4 hover:underline">
              {item.label}
            </Link>
          ) : (
            <span>{item.label}</span>
          )}
          {index < items.length - 1 ? <span className="mx-2">{separator}</span> : null}
        </span>
      ))}
    </div>
  );
}
